/**
* File: MatchBulkUploadController.js
* Project: educore
* Created Date: 2018-12-07
* Author: Arul Mozhi J
* Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
* ------------------------------------
*/
import bulkUpload from '../views/popup/matchBulkPopup.html'
class MatchBulkUploadController {
   // @ngInject
   constructor($scope, $rootScope, authService, localStorageService, $state, CQuesConst,$mdDialog,$mdMedia) {
       //On init function
       this.$onInit = () => {
           $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
           $rootScope.title = "Archives"
           if (!$rootScope.isLoggedIn) {
               $state.go("login", {}, {
                   reload: true
               })
           }
       }
       //On destroy function
       this.$onDestroy = () => {
       }
       let userId = localStorageService.get("user_id")
        let schoolId = localStorageService.get("school_id")
        let sessionDetails = localStorageService.get("createQuesiton")
        $scope.is_traditional_activity=$scope.$parent.isTActivityQuestion
        $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion
        $scope.is_archive=$scope.$parent.isArchiveQuestion
        $scope.showViewButton = false;
        let SAVE_URL = CQuesConst.API_CREATE_BULK_MTF
        let qp_id=$scope.$parent.tqp_id
        $scope.csvDownloadLink = '../../../img/csv-samples/MTF-CSV-Sample.csv'
        $scope.currentTheme = $scope.$parent.$parent.theme.det
        $scope.strandsArray = $scope.$parent.$parent.strandsList
                //[Object] - Wave details
        $scope.waveDetails = $scope.$parent.$parent.waveDetails

            //[Object] - Theme details of current subject
        $scope.themesArray = $scope.$parent.$parent.themesArray

            //[Object] - Subject details
        $scope.linkSubjects = $scope.$parent.$parent.linkSubjects

            //[Object] - Theme with subject details except current subject
        $scope.linkThemes = $scope.$parent.$parent.linkThemes

            //Boolean - Whether the activity is practice or not
        //$scope.isPractice = $scope.$parent.isPractice
        $scope.skillList = CQuesConst.SKILL_LIST
        let authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId,
            user_id: userId
        }
        $scope.content_editor_id = userId;
        function validate(obj)
        {
            let errors={}
             //Validation  
            if (obj.question == null || obj.question == undefined || obj.question == "") {
              errors.question = "Question is required";
                //activityErrorCount++;
            } else if (obj.question.split('&&').length !=obj.correctAnswer.split('&&').length) {
                errors.question = "Question and option count should match";
                //activityErrorCount++;
            }
            if (obj.correctAnswer == null || obj.correctAnswer == undefined || obj.correctAnswer == "") {
                errors.corect_answer= "Answer is required"
                //activityErrorCount++;
            }
            else if (obj.question.split('&&').length !=obj.correctAnswer.split('&&').length) {
                errors.corect_answer = "Question and option count should match";
                //activityErrorCount++;
            }
            if ($scope.is_archive) {
          
            } else {
                if (obj.theme) {
                    if (!obj.theme.theme_id) {
                        errors.theme = "Select theme"
                       // activityErrorCount++;
                    }
                } else {
                    errors.theme = "Select theme"
                    //activityErrorCount++;
                }
            }
           
            if (obj.strand) {
                if (obj.strand.length <= 0) {
                    errors.strand = "Enter strand"
                    //activityErrorCount++;
                }
            } else {
                errors.strand = "Enter strand"
                //activityErrorCount++;
            }
            if (obj.level) {
                if (obj.level.length <= 0) {
                    errors.level = "Enter level"
                    //activityErrorCount++;
                }
            } else {
                errors.level = "Enter level"
                //activityErrorCount++;
            }
            if (obj.wave) {
                if (obj.wave.length <= 0) {
                errors.wave = "Enter wave"
                    //activityErrorCount++;
                }
            } else {
                errors.wave = "Enter wave"
                //activityErrorCount++;
            }
            if (obj.cognitive_skills) {
                if (obj.cognitive_skills.length <= 0) {
                    errors.cognitive_skills = "Enter skill"
                    //activityErrorCount++;
                }
            } else {
                errors.cognitive_skills = "Enter skill"
                //activityErrorCount++;
            } 
            return errors
    }
        var bulkUploadCtrl = function ($scope, $mdDialog,bulkUploadData,skillList,waveDetails,linkSubjects,themesArray,is_traditional_activity,is_tp_activity,is_archive,current_theme) {
            $scope.bulkUploadData =bulkUploadData
            $scope.skillList = skillList
            $scope.waveDetails = waveDetails
            $scope.linkSubjects= linkSubjects
            $scope.themesArray=themesArray
            $scope.is_traditional_activity=is_traditional_activity
            $scope.is_tp_activity = is_tp_activity
            $scope.is_archive=is_archive
            $scope.currentTheme=current_theme
            $scope.errors=[]
            $scope.save = function() {
                $scope.errors=[]
                let obj = {
                    "subject_id": authoring.subject_id,
                    "school_id": authoring.school_id,
                    "xclass_id": authoring.class_id,
                    "curriculum_id": authoring.curriculum_id,
                    "content_manager_id": $scope.content_editor_id,
                    "session_id": authoring.session_id,
                    "batch_id": authoring.batch_id,
                    "class_id": authoring.class_id,
                    "is_traditional_activity":$scope.is_traditional_activity,
                    "activity_id": sessionDetails.activity_id,
                    "user_id": userId
                }
                //Validation  
                _.each($scope.bulkUploadData, function(question_val, question_key) {
                    if(question_val.theme)
                    {
                        question_val.question_theme_name = question_val.theme.theme_name;
                        question_val.question_theme_id = question_val.theme.theme_id;
                    }
                    if($scope.is_archive)
                    {
                        question_val.question_theme_id=$scope.currentTheme.theme_id
                    }
                    question_val.isLatex=false;
                    question_val.content_editor_id = userId;
                    question_val.subject_id=authoring.subject_id
                    question_val.school_id= authoring.school_id
                    let errors = validate(question_val)
                    if(Object.keys(errors).length>0)
                    $scope.errors.push(errors)
                    })
                if($scope.errors.length==0)
                {
                obj.ques_list = $scope.bulkUploadData
                 //SAVE CALL
                 authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId:qp_id
                            })
                            toastr.success("Question Saved successfully");
                        } else if(is_tp_activity){
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            })
                            toastr.success("Question Saved successfully");
                        }else {
                            if(result.data.isExists){
                                toastr.success("Question already exists");
                            }else{
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession()
                            }
                        }
                        $scope.cancel()
                    }  else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");

                        }
                           $rootScope.setHideSaveButton(false)
                           $rootScope.setLoader(false)
                           //toastr.error("Network Error")
                       }
                    _.defer(() => { $scope.$apply() })
                })
            }
            else
            return false;
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
    
            
        }

        //Import CSV file
        $scope.upload = function(file) {  
          if (file != undefined && file.name != undefined) {
                let extValue = file.name.split('.').pop();
                if ( extValue === 'csv') {
                    $scope.isSupportedFormat = true
                    if (!$scope.strandsArray) {
                        toastr.error("No strands has been added to the Subject. Contact content manager.")
                        return false
                    }
                    Papa.parse(file, {
                        skipEmptyLines: true,
                        complete: function(results) {
                            $scope.showViewButton = true;
                            $scope.bulkUploadData = [];
                            let data = results ? results.data : [];
                            let countQ = data.length - 1
                            if (data[countQ].length === 1) {
                                data.splice(countQ, 1)
                            }
                            data.forEach(function(question, index) {
                                if (index !== 0) {
                                    //[String] - question level
                                    let level = []

                                    //[String] - student wave
                                    let wave = []

                                    //[String] - subject strands
                                    let strands = []

                                    //[String] - Link subjects
                                    let linkSub = [];

                                    //[String] - Link Themes
                                    let linkTheme = []

                                    //[String] - Cognitive Skills
                                    let cognitive_skills=[]

                                    if (question[3])
                                        level = question[3].split('&&');
                                    if (question[4])
                                        wave = question[4].split('&&').map(function(val) {
                                            return "w00" + val
                                        });
                                    if (question[7]) {
                                        linkSub = question[7].split('&&');
                                    }
                                    if (question[8]) {
                                        linkTheme = question[8].split('&&');
                                    }
                                    if (question[10]) {
                                      cognitive_skills = question[10].split('&&');
                                    }
                                    let qbObj = {
                                        "question": question[0],
                                        "correctAnswer": question[1],
                                        "correctAnswerExpl": question[2],
                                        "level": level,
                                        "wave": wave,
                                        "strand": question[5],
                                        "theme": question[6],
                                        "cxLinkObj": {
                                            "subject": linkSub,
                                            "theme": linkTheme
                                        },
                                        "tags": question[9],
                                        "cognitive_skills": cognitive_skills
                                    }
                                    $scope.bulkUploadData.push(qbObj)
                                }
                            })
                            _.defer(() => { $scope.$apply() })
                        }
                    })
                    toastr.success("Successfully uploaded")
                } else {
                    $scope.isSupportedFormat = false
                    $scope.showViewButton = false
                    toastr.error("Please select .csv format")
                }
            }
        };

        //Display CSV
        $scope.showCsv = function() {
            _.each($scope.bulkUploadData, function(data) {

                //[Object] - Selected Link Subject
                let linkSubject = [];

                //[Object] - Selected Link Theme
                let linkTheme = [];

                //Object -Selected theme
                // let themeObj = _.find($scope.themesArray, function(theme) {
                //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
                // })
                // if (themeObj) {
                //     data.theme = {
                //         theme_name: themeObj.theme_name,
                //         theme_id: themeObj.theme_id
                //     }
                // } else {
                //     data.theme = {
                //         theme_name: $scope.currentTheme.theme_name,
                //         theme_id: $scope.currentTheme.theme_id
                //     }
                // }
                let skills = []
                data.cognitive_skills =_.map(data.cognitive_skills, function (skill) {
                    return skill.toLowerCase()
                  })
                  _.each($scope.skillList, function (skill) {
                    let skill_lc = skill.toLowerCase()
                    if (_.contains(data.cognitive_skills, skill_lc)) {
                      skills.push(skill)
                    }
                  })
                  data.cognitive_skills = skills
                _.each(data.cxLinkObj.subject, function(subject) {
                    let subjectId = _.find($scope.linkSubjects, function(sub) {
                        return sub.name === subject
                    })
                    if (subjectId)
                        linkSubject.push({
                            name: subjectId.name,
                            _id: subjectId._id
                        })
                })
                data.linkSubject = linkSubject;
                // _.each(data.cxLinkObj.theme, function(theme) {
                //     let themeId = _.find($scope.linkThemes, function(themeObj) {
                //         return themeObj.theme_name === theme
                //     })
                //     if (themeId)
                //         linkTheme.push(themeId)
                // })
                // data.linkTheme = linkTheme;
            })
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                template: bulkUpload,
                locals: {
                    bulkUploadData: $scope.bulkUploadData,
                    skillList:$scope.skillList,
                    waveDetails:$scope.waveDetails,
                    linkSubjects:$scope.linkSubjects,
                    themesArray:$scope.themesArray,
                    is_traditional_activity:$scope.is_traditional_activity,
                    is_archive:$scope.is_archive,
                    current_theme:$scope.currentTheme,
                    is_tp_activity:$scope.is_tp_activity
                  },
                controller: ['$scope', '$mdDialog','bulkUploadData','skillList','waveDetails','linkSubjects','themesArray','is_traditional_activity','is_tp_activity','is_archive','current_theme', bulkUploadCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        };   
   }
}

export default MatchBulkUploadController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/matchBulkUploadController.js